// extracted by mini-css-extract-plugin
export default {"AboutMe":"AboutMe_AboutMe__rca85","resumeDiv":"AboutMe_resumeDiv__+AV6d","resume":"AboutMe_resume__tAhA5","profile":"AboutMe_profile__YbLkX","Typewriter":"AboutMe_Typewriter__bwlxY"};